import { useState } from 'react';
import { Link } from 'react-router-dom';
import useMain from '../../../../hooks/useMain';
import DigitalWatch from '../../../common/digitalWatch';
import Image from '../../../common/image';
import { TextCard } from '../../ingredients/cards';

const Contest = () => {
	const { initData, uiInfo } = useMain();
	const { isLessThanMD } = uiInfo;
	const { end, start } = initData.contests.millionairesChallenge2;
	const [isFinished, setIsFinished] = useState(Date.now() >= end);
	if (Date.now() < start || Date.now() > end + 10 * 24 * 60 * 60 * 1000) return null;

	return (
		<div className='row'>
			<div className='col-sm-12'>
				<Link to='/dashboard/bonus/millionairesChallenge2'>
					<TextCard
						className='mb-4 millionairesChallenge2 position-relative'
						text={
							<div className='row py-4 py-lg-3 gy-5 align-items-center text-light'>
								<div className='col-lg-4 col-12 text-center'>
									<Image
										className={`w-${isLessThanMD ? '50' : '50'}`}
										fileName='millionaires2/club.webp'
									/>
								</div>
								<div className='col-lg-4 col-12 text-center'>
									<Image
										className={`mb-4 w-${isLessThanMD ? '100' : '75'}`}
										fileName='millionaires2/logo.webp'
									/>
									{isFinished ? (
										<h4>Event is ended.</h4>
									) : (
										<>
											<div>
												<div>Remaining Time:</div>
												<DigitalWatch
													className='d-inline-block'
													onComplete={() => setIsFinished(true)}
													date={end}
												/>
											</div>
										</>
									)}
								</div>

								<div className='col-lg-4 col-12 text-center'>
									<div>
										<Image
											className={`${isLessThanMD ? 'w-50 mb-5' : 'w-50'}`}
											fileName='millionaires2/top10.webp'
										/>
									</div>
								</div>
							</div>
						}
					/>
				</Link>
			</div>
		</div>
	);
};

export default Contest;
